module.exports = __webpack_public_path__ + "img/thinking-process-done.456925c.gif";